import { ApiResponse } from './../../models/response-api';
import { environment } from './../../../../environment/environment';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EvaluationService extends CrudService<ApiResponse<any>, number>{

  constructor(_http: HttpClient) { 
    super(_http, `${environment.baseUrl}`) 
  }

  addTemplate(data: any): Observable<ApiResponse<any>>{
    return this._http.post<ApiResponse<any>>(this._base+`/api/evalEsn/template/create`, data);
  }

  /*question*/
listQuestion(template_id: any) {
  return this._http.get<ApiResponse<any>>(
    `${this._base}/api/evalAdmin/question/questionEval/${template_id}`
  );
}

  updateTemplate(idEvaluation: string, data: any): Observable<ApiResponse<any>>{
    return this._http.post<ApiResponse<any>>(`${this._base}/api/evalEsn/template/${idEvaluation}/update`, 
        data);
  }

  fetchTemplates(data: any): Observable<ApiResponse<any>> {
    const params: any = {
      per_page: data.per_page,
      page: data.page + 1,
      ...(data.template_type ? { template_type: data.template_type } : {}),
      ...(data.template_name ? { template_name: data.template_name } : {}),
      ...(data.template_date ? { template_date: data.template_date } : {}),
    };
    const url = `${this._base}/api/evalEsn/tempalte-esn`;
    return this._http.get<ApiResponse<any>>(url, { params });
  }

  getTemplateDetails(idEvaluation: number | null, page : number, perPage : number): Observable<ApiResponse<any>>{
    return this._http.get<ApiResponse<any>>(`${this._base}/api/evalEsn/template/${idEvaluation}?page=${page}&per_page=${perPage}`)
  }

  getTemplateQuestions(idEvaluation: number | null): Observable<ApiResponse<any>>{
    return this._http.get<ApiResponse<any>>(`${this._base}/api/evalEsn/question/questionEval/${idEvaluation}`)
  }

  addQuestion(data: any): Observable<ApiResponse<any>>{
    return this._http.post<ApiResponse<any>>(`${this._base}/api/evalEsn/question/create`, data);
  }
  updateMultipleSteps(data: any): Observable<ApiResponse<any>>{
    return this._http.post<ApiResponse<any>>(`${this._base}/api/evalEsn/question/updateMultipleSteps`, data);
  }

  getTemplateSubjects(data : any): Observable<ApiResponse<any>>{
    const params: any = {
        per_page: data.per_page,
        page: data.page + 1,
        ...(data.search ? { search: data.search } : {}),
      };
      const url = `${this._base}/api/evalEsn/family/eval-family-esn-list`;
      return this._http.get<ApiResponse<any>>(url, { params });
  }
  addSubject(data: any): Observable<ApiResponse<any>>{
    return this._http.post<ApiResponse<any>>(this._base+`/api/evalEsn/family/create`, data);
  }

  getAllSubjects(): Observable<ApiResponse<any>>{
    return this._http.get<ApiResponse<any>>(`${this._base}/api/evalEsn/family/family-esn-list`)
  }

  sendTemplate(idTemplate: string, data: any): Observable<ApiResponse<any>>{
    return this._http.post<ApiResponse<any>>(`${this._base}/api/evalEsnSent/sendEvaluation/${idTemplate}`, data);
  }

  fetchSentTemplates(data: any): Observable<ApiResponse<any>> {
    const params: any = {
      per_page: data.per_page,
      page: data.page + 1,
      ...(data.name_eval ? { name_eval: data.name_eval } : {}),
      ...(data.type_eval ? { type_eval: data.type_eval } : {}),
      ...(data.status_eval ? { status: data.status_eval } : {}),
      ...(data.name_consultant ? { name_consultant: data.name_consultant } : {}),
      ...(data.start_date ? { start_date: data.start_date } : {}),
      ...(data.end_date ? { end_date: data.end_date } : {}),
    };
    const url = `${this._base}/api/evalEsnSent/getEvaluationSendsByCompanyId`;
    return this._http.get<ApiResponse<any>>(url, { params });
  }

  getSentEvaluationDetails(idEvaluation: number | null): Observable<ApiResponse<any>>{
    return this._http.get<ApiResponse<any>>(`${this._base}/api/evalEsnSent/getEvaluationDetails/${idEvaluation}`)
  }

  savePv(data: any): Observable<ApiResponse<any>>{
    return this._http.post<ApiResponse<any>>(`${this._base}/api/pvEsn/addPvReport`, data);
  }

  updatePv(idPV : string,data: any): Observable<ApiResponse<any>>{
    return this._http.put<ApiResponse<any>>(`${this._base}/api/pvEsn/updatePvReport/${idPV}`, data);
  }

  sendPv(idPV: string): Observable<ApiResponse<any>>{
    return this._http.post<ApiResponse<any>>(`${this._base}/api/pvEsn/sendPvToConsultant/${idPV}`, null);
  }

  fetchPvList(data: any): Observable<ApiResponse<any>> {
    const params: any = {
      per_page: data.per_page,
      page: data.page + 1,
      ...(data.signature_status ? { signature_status: data.signature_status } : {}),
      ...(data.consultant_name ? { consultant_name: data.consultant_name } : {}),
      ...(data.evaluation_name ? { evaluation_name: data.evaluation_name } : {}),
      ...(data.evaluation_type ? { evaluation_type: data.evaluation_type } : {}),
      ...(data.start_date ? { start_date: data.start_date } : {}),
      ...(data.end_date ? { end_date: data.end_date } : {}),
    };
    const url = `${this._base}/api/pvEsn/getPvReportByCompany`;
    return this._http.get<ApiResponse<any>>(url, { params });
  }

}